/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppInsightsActionableRecommendationsWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("AppInsightsActionableRecommendationsWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return AppInsightsActionableRecommendationsWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<AppInsightsActionableRecommendationsWidgetConfiguration>): AppInsightsActionableRecommendationsWidgetConfiguration {
        let obj = Object.assign(new AppInsightsActionableRecommendationsWidgetConfiguration(), model);
        AppInsightsActionableRecommendationsWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppInsightsActionableRecommendationsWidgetConfiguration>): AppInsightsActionableRecommendationsWidgetConfiguration {
        if (!model) return null;
        return AppInsightsActionableRecommendationsWidgetConfiguration.newInstance(<AppInsightsActionableRecommendationsWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppInsightsActionableRecommendationsWidgetConfiguration) {
        if (!obj) return;

        models.AppInsightsActionableRecommendationsWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppInsightsActionableRecommendationsWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppInsightsActionableRecommendationsWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
